
import React, { useState, useEffect } from 'react';
import GasFormField from './GasFormField';
import { showError, fetchWithRetry } from '../../utils';
import {saveContent, getContent} from '../../api'
import { useLocation } from 'react-router-dom';
import Card from "./Card";
import Page from './Page';
import AccordionItem from './AccordionItem';
import Loader from './Loader';
import useConfirm from '../../hooks/useConfirm';
import useAlert from '../../hooks/useAlert';

export default function GasForm({
    title,
    getAction,
    saveAction,
    saveBtnText="Salva",
    saveBtnPosition = "start-fixed",
    preComponent = null,
    postComponent = null,
    showConfirmation = false,
    showOnlyFields = false
}) {

    
    const [model, setModel] = React.useState(null);
    const keys = model ? Object.keys(model) : [];   
    const [formFields, setFormFields] = React.useState(null);
    const [isSaving, setIsSaving] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const confirm = useConfirm();
    const alert = useAlert();

    //qui devo prendere l'id usando react-router-dom, se esiste
    const location = useLocation();
    const id = location.state?.id;
    //se op non è passato, lo calcolo in base all'id: se id esiste, op è 'edit', altrimenti 'add'
    const op = location.state?.op ? location.state?.op : (id ? 'edit' : 'add'); 


    let getActionUrl = getAction.replace("{id}", id ? id : "new");

    React.useEffect(() => {
        let ignore = false;
        // Caricamento modello e campi del form
        const fetchModel = async () => {
            setIsLoading(true);
            const fetchedModel = await getContent(getActionUrl);
            if (ignore) return;
            
            let newModel = {};
            let newFormFields = {};
            Object.keys(fetchedModel).forEach(key => {
                newModel[key] = fetchedModel[key].model;
                newFormFields[key] = fetchedModel[key].metadata;
                if (showOnlyFields){
                    // Filtra i campi del modello e del formFields in base a showOnlyFields: showOnlyFields è un array di chiavi contenute in  newModel[key]
                    Object.keys(newModel[key]).forEach(keyFormField => {
                        if (!showOnlyFields.includes(keyFormField)) {
                            delete newModel[key][keyFormField];
                            delete newFormFields[key][keyFormField];
                        }
                    });

                }
            });
            
            setIsLoading(false);
            setModel(newModel);
            setFormFields(newFormFields);
        };
        
        fetchWithRetry(fetchModel, ignore)
        .catch(err => {
            if (!ignore) {
                setIsLoading(false);
                showError([err.message]);
            }
        });

        return () => {
            ignore = true; // Imposta ignore a true quando il componente viene smontato
        }
        
    }, []);


    const handleChangeFormField = (key, fieldIndex, props) => {
        setModel((prevModel) => {
            const updatedModel = {...prevModel};
            updatedModel[key][fieldIndex] = props.target.value;
            return updatedModel;
        });
    }

    const performSave = async () => {
        setIsSaving(true);
        try {
            await saveContent(saveAction, model);
            alert({message: "Modifiche salvate con successo!", type: "success"});
        } catch (error) {
            showError([error.message]);
        } finally {
            setIsSaving(false);
        }
    };

    const handleSave = async () => {
      if (showConfirmation) {
        const ok = await confirm({
          message: 'Sei sicuro di voler salvare le modifiche?'
        });
        if (ok) performSave();
      } else {
        performSave();
      }
    };

    if (isLoading) {
        return (
            <Page title={title}>
                <Loader />
            </Page>
        );        
    }

    const gasform = model && 
        <div className="gas-form"> 
            <div class="form-header">
                {saveBtnPosition === "start-fixed" && op !== 'show' && (                   
                    <div className="form-save-fixed">                  
                        <button className="submit" onClick={handleSave} disabled={isSaving}>
                             {saveBtnText}
                        </button>
                    </div>
                )}
            </div>
            <div style={{marginTop: saveBtnPosition === "start-fixed" && op !== 'show' ? '2rem' : '0'}}>
                <Card content={keys.map((key, index) => {
                    const formFieldsRender = 
                        <div className="form-fields">
                            {formFields && formFields[key] && Object.keys(formFields[key]).map((fieldIndex) => (
                                <GasFormField key={`${key}_${fieldIndex}`}
                                            op={op}  
                                            fieldOptions={formFields[key][fieldIndex]}
                                            index={fieldIndex}
                                            value={model[key][fieldIndex]}
                                            onChange={(props) => handleChangeFormField(key, fieldIndex, props)}
                                />
                            ))}
                        </div>;
                    
                    return (
                        <form key={index} className="form">
                            {keys.length > 1 ? <AccordionItem title={key.charAt(0).toUpperCase() + key.slice(1)}>
                                {formFieldsRender}
                            </AccordionItem> : formFieldsRender
                            }
                        
                        </form>
                )})}  /> 
            </div>   
            
            {saveBtnPosition === "end" && op !== 'show' && ( 
                <div style={{margin: '1rem'}}>                  
                    <button className="submit" onClick={handleSave} disabled={isSaving}>
                         {saveBtnText}
                    </button>
                </div>
            )}
        </div>;

   
    return (
        <Page title={title}>
            {preComponent}
            {gasform}
            {postComponent}
        </Page>
    );
       

}